import { SalesforceObjectType } from "@amzn/ads-measurement-plm-service-type-script-client";

import type { SfObject } from "../store/insightLinkage";
import { SfObjectType } from "../store/insightLinkage";

import { NOT_CREATED_DROPDOWN_VALUE } from "./salesforce.utils";

export const resolveSfObjectId = (sfObject: SfObject): string => {
    return sfObject.sfObjectId === NOT_CREATED_DROPDOWN_VALUE
        ? ""
        : sfObject.sfObjectId;
};

export const resolveOpportunityId = (sfObject: SfObject): string => {
    if (sfObject.sfObjectType !== SfObjectType.OPPORTUNITY) {
        return "";
    }

    return resolveSfObjectId(sfObject);
};

export const resolveSfObjectType = (
    sfObject: SfObject,
): SalesforceObjectType => {
    return sfObject.sfObjectId === NOT_CREATED_DROPDOWN_VALUE
        ? SalesforceObjectType.ACCOUNT_ONLY
        : sfObject.sfObjectType;
};
